import { useLocation } from 'react-router';

import { INCODE_EARLY_DOCS_SLUG, INCODE_POST_SALE_SLUG } from 'Utilities/routing';

const IS_PROD = process.env.APPLICATION_ENVIRONMENT === 'production';

const INCODE_DOMAIN = IS_PROD ? 'saaseu-api' : 'demo-api';

export const API_URL = `https://${INCODE_DOMAIN}.incodesmile.com/0/`;

export const INCODE_ROUTES = {
  CAPTURE_LICENSE: '/capture-license',
  COMPLETE: '/complete',
  PROOF_OF_ADDRESS: '/proof-of-address',
  SELFIE: '/selfie',
  V5C: '/V5C',
};

export const POST_INCODE_ROUTE = '/purchasing-dealer-details';

export const INCODE_PROGRESS_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'successful',
} as const;

export const INCODE_PROGRESS_STEP = {
  CONSENT: 'consent',
  DRIVING_LICENCE: 'driving_licence',
  FINGERPRINT: 'fingerprint',
  PROOF_OF_ADDRESS: 'poa',
  SELFIE: 'selfie',
  V5: 'v5',
} as const;

export const SENTRY_TAG = {
  tags: {
    feature: 'IncodeSDK',
  },
};

export const INCODE_BE_ROUTES: Partial<Record<
  typeof INCODE_PROGRESS_STEP[keyof typeof INCODE_PROGRESS_STEP],
  string
>> = {
  [INCODE_PROGRESS_STEP.CONSENT]: '',
  [INCODE_PROGRESS_STEP.DRIVING_LICENCE]: INCODE_ROUTES.CAPTURE_LICENSE,
  [INCODE_PROGRESS_STEP.SELFIE]: INCODE_ROUTES.SELFIE,
  [INCODE_PROGRESS_STEP.V5]: INCODE_ROUTES.V5C,
  [INCODE_PROGRESS_STEP.PROOF_OF_ADDRESS]: INCODE_ROUTES.PROOF_OF_ADDRESS,
};

export type IncodeProgressStatus = {
  status: typeof INCODE_PROGRESS_STATUS[keyof typeof INCODE_PROGRESS_STATUS];
  step: typeof INCODE_PROGRESS_STEP[keyof typeof INCODE_PROGRESS_STEP];
};

export type IncodeSDK = {
  [key: string]: (...args: any[]) => any;
};

export type IncodeStepProps = {
  BASE_URL: string;
  DP_ENQUIRY_ID: number;
  incodeSDK: IncodeSDK;
  incodeSession?: {
    consentId: string;
    id: string;
    interviewId: string;
    saleId?: string;
    token: string;
  };
};

export const useIncodeSlug = () => {
  const { pathname } = useLocation();

  return pathname.includes(INCODE_EARLY_DOCS_SLUG) ? INCODE_EARLY_DOCS_SLUG : INCODE_POST_SALE_SLUG;
};
